import { ErrorHandler, Injectable, Injector, NgZone, inject } from '@angular/core';
import { NotificationService } from '../notifications/notification.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
    private injector = inject(Injector);
    private zone = inject(NgZone);

    handleError(error: Error) {
        const notificationService = this.injector.get(NotificationService, null);

        if (notificationService != null) {
            this.zone.run(() => notificationService.error(error));
        } else {
            console.error(`L'erreur n'a pu être affiché dans la fenêtre de notification: ${error.message}`, error);
        }
    }
}
